import { CarrierType, CarrierVisitsApi, CarrierVisitStatus } from '@operations/app/api'
import { createApiClient } from '@operations/app/http-client'

class CarrierVisitService {
  httpClient = createApiClient(CarrierVisitsApi)

  async getVisitPerformance(carrierVisitId: number) {
    const { data } = await this.httpClient.getVisitPerformance(carrierVisitId)

    return data
  }

  async getExecutedMovesPerCrane(carrierVisitId: number) {
    const { data } = await this.httpClient.getExecutedMovesPerCrane(carrierVisitId)

    return data
  }

  async getCarrierVisitsByPartialName(
    filter?: string,
    type?: CarrierType,
    statuses: CarrierVisitStatus[] = [],
  ) {
    if (!filter) return []

    const { data } = await this.httpClient.getCarrierVisitAreasByPartialName(filter, type, statuses)

    return data
  }

  async getCarrierVisitsWithWorkQueues(statuses: CarrierVisitStatus[] = [], ids: number[]) {
    const { data } = await this.httpClient.getCarrierVisitsWithWorkQueues(ids, statuses)

    return data
  }
}

const carrierVisitService = new CarrierVisitService()

export default carrierVisitService
